module.exports = __webpack_public_path__ + "img/Meli-Enviame.eedefbc4.png";